import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IListResponse, Nullable } from '@lib/interfaces';
import { TColumn, TColumnSort } from '@lib/modules/table/components';
import { TableModule } from '@lib/modules';
import { CustomersBeneficiaryService } from '@lib/services/customers/customers-beneficiary.service';
import { BaseComponent } from '@lib/components';

@Component({
  selector: 'app-tab-alias',
  standalone: true,
  imports: [CommonModule,TableModule],
  templateUrl: './tab-alias.component.html',
  styleUrls: ['./tab-alias.component.scss']
})
export class TabAliasComponent  extends BaseComponent implements OnInit {

  @Input() customerId = '';
  public aliasList: Array<any> = [];
  public aliasListLoading = false;
  public hasMoreRecords = false;
  protected columns: Array<TColumn> = [
    'name',
    'email',
    'phone',
    'nickname',
    'category',
    'category_display_name',
    'subcategory',
    'subcategory_display_name',
    'instrument_currency',
    'instrument_type',
    'instrument_value',
    'is_deleted',
    'status',
    'created'
  ];
  protected defaultColumns: Array<string> = ['name', 'email', 'phone', 'status', 'created'];
  protected sortableColumns: Array<string> = ['created'];

  constructor(private customerBeneficiaryService:CustomersBeneficiaryService){
    super();
  }
  private fetchAliases(limit = 10): void {
    this.addSubscription(
        this.customerBeneficiaryService.getBeneficiaryDetails(this.customerId,'Alias_Transfer').subscribe({
            next: (aliasListResponse: IListResponse<any>): void => {
                this.hasMoreRecords = aliasListResponse.has_more;
                this.aliasList = [...aliasListResponse.data];
                this.aliasListLoading = false;
            },
            error: (): void => {
                this.aliasListLoading = false;
            },
        }),
    );
  }

  public ngOnInit(): void {
    this.aliasListLoading = true;
    this.fetchAliases(10);
  }

}
